import Navbar from "../../../NavBar/Navbar"
import SideBar from "../../../NavBar/Sidebar"
import DetalleContent from "./DetalleContent"

interface ChildsProps {
    logout: () => void
}

const DetallesGuia: React.FC<ChildsProps> = ({logout}) => {

    

    return(
    <div className="sidebar-noneoverflow">
        <Navbar logout={logout}/>
    
        <div className="main-container" id="container">
            <SideBar/>
            <DetalleContent/>
        </div>
    </div>
    )
}


export default DetallesGuia